import script from "./HelpCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpCollapse.vue?vue&type=script&setup=true&lang=ts"

import "./HelpCollapse.vue?vue&type=style&index=0&id=0da4423c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da4423c"]])

export default __exports__